// Define localStorage keys
export const STORAGE_KEY_PREFIX = 'nstyj_player_';
export const STORAGE_KEYS = {
  CURRENT_SONG: `${STORAGE_KEY_PREFIX}current_song`,
  CURRENT_TIME: `${STORAGE_KEY_PREFIX}current_time`,
  VOLUME: `${STORAGE_KEY_PREFIX}volume`,
  IS_MUTED: `${STORAGE_KEY_PREFIX}is_muted`,
  REPEAT_MODE: `${STORAGE_KEY_PREFIX}repeat_mode`,
  SHUFFLE_MODE: `${STORAGE_KEY_PREFIX}shuffle_mode`,
};

export interface Song {
  id: string;
  name: string;
  path: string;
  songUrl?: string;
  coverUrl?: string;
  videoUrl?: string;
  duration?: string;
  lyrics?: any;
  hlsUrl?: string;
  isHls?: boolean;
  trackNumber?: number;
  downloadable?: boolean;
}

export interface Album {
  id: string;
  name: string;
  path: string;
  coverUrl?: string;
  songs: Song[];
  downloadable?: boolean;
}

export interface MusicPlayerProps {
  onVisualizerUpdate?: (analyser: AnalyserNode | null, isPlaying: boolean) => void;
}

export interface MediaErrorWithMessage extends MediaError {
  message: string;
}

// Repeat mode enum
export type RepeatMode = 'none' | 'album' | 'song';

// Shuffle mode enum
export type ShuffleMode = 'none' | 'album' | 'all'; 